export const onboardingReducerKey = "onboarding";
export const onboardingInitialState = {
  userId: null,
  firstName: "",
  lastName: "",
  email: "",
  country: "",
  companyName: "",
  useCase: "home",
  chargingSetup: "",
  acceptedTerms: false,
};